// extracted by mini-css-extract-plugin
export default {"footer":"piAfFdzg0ukqHg55AVpJ__footer___"};